import React, { FC, useMemo } from "react";
import { RouterParamType } from "@/model/navModel";
import { YhBox } from "@/components/YhBox";
import { Table } from "antd";
import { ColumnsType } from "antd/lib/table";
import { useOutputDetailsModel } from "./stockOutputModelDetails";
import { roleColumnModel } from "@/utils/roleColumn";
import useGlobalModel from "@/model/globalModel";
import YhTootip from "@/components/YhTootip";
export const TableBox: FC<RouterParamType> = ({ id, mode }) => {
    const { detailLookList, detailLookForm } = useOutputDetailsModel();
    const { user: { roles } } = useGlobalModel();
    const { getRoleColumns } = roleColumnModel();

    const columns: ColumnsType<any> = [
        {
            title: '序号',
            fixed: "left",
            width: 80,
            render: (t: any, r: any, i: number) => <>{i + 1}</>
        }, {
            title: '配件编码',
            width: 120,
            dataIndex: 'materialCode',
            render: (text: any) => <YhTootip text={text} />,
        }, {
            title: '配件名称',
            width: 160,
            dataIndex: 'materialName',
            render: (text: any) => <YhTootip text={text} />,
        }, {
            title: '所属库房',
            width: 160,
            dataIndex: 'warehouseName',
        }, {
            title: '所属货位',
            width: 160,
            dataIndex: 'shelfCode',
        }, {
            title: '数量',
            width: 160,
            dataIndex: 'num',
        }, {
            title: '单价',
            width: 120,
            dataIndex: 'price',
        },

        ...(detailLookForm.tradeTypeCode == 'trade-type.purchase-return' ? [] : [{
            title: '折扣',
            width: 120,
            dataIndex: 'discountRate',
            render: (text: string) => text + "%"
        },]),
        {
            title: '总计',
            width: 120,
            dataIndex: 'amount',
        }
    ]

    const roleColumns = useMemo(() => {
        //根据可视化配置处理需要展示相关列
        const params = { "code": "stockOut", "roleCodes": roles };
        return getRoleColumns("stockOut", "明细", columns, params);
    }, [roles, detailLookList]);

    return (
        <YhBox title="商品信息" >
            <Table
                bordered
                columns={roleColumns}
                dataSource={detailLookList}
                pagination={false}
                scroll={{ x: 'max-content', y: 400 }}
            >
            </Table>
        </YhBox>
    )
}